import React, { Component } from "react";
import {
  Button,
  Banner,
  Text,
  Box
} from "@shopify/polaris";
import PageHelmet from "components/PageHelmet";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "helpers/withRouter";
import { isEmail, isLatin } from "utils/validation";
import moment from "moment";
import "moment-timezone";
import { fetchAllCountries } from '../../../../redux/features/other/otherSlice'
import { activateResend, registerUser } from '../../../../redux/features/user/userSlice'
import AuthContainer from "../../AuthContainer";
import config from "config";

import { createCustomDispatch } from "helpers/customDispatch";
import SignUpStep1 from './SignUpStep1';
import SignUpStep2 from './SignUpStep2';

let recaptchaResponse = undefined;

function submitRecaptcha(response) {
  recaptchaResponse = response;
}
function expiredRecaptcha() {
  recaptchaResponse = undefined;
}


const categoryDescriptions = {
  "L`Tax": "Add L’Tax to your menu to manage tax obligations.",
  "L`EPR": "Add L’EPR to your menu to handle EPR requirements.",
  "L`Invoice": "Add L’Invoice to your menu to send and track e-invoices."
};

class SignUp extends Component {
  registerProjectError = '';

  constructor(props) {
    super(props);

    this.state = {
      		step: 1, // registration step
      email: "",
      errorEmail: false,
      surname: "",
      errorSurname: false,
      companyName: "",
      errorCompanyName: false,
      errorCountry: false,
      defaultTimezone: moment.tz.guess(),
      countriesOptions: [],
      referral_token: "",
      country: "",
      		selectedCategories: ['L`Tax', 'L`EPR', 'L`Invoice'], // all selected by default
      selectedApp: null,
      registerProjectError: '',
    };
  }

  isCategoryChecked = (category) => {
    return this.state.selectedCategories.includes(category);
  }

  handleCategoryChange = (category) => {
    this.setState((prevState) => {
      const { selectedCategories } = prevState;
      if (selectedCategories.includes(category)) {
        		// If trying to uncheck the last checkbox — don't allow
        if (selectedCategories.length === 1) {
          return null;
        }
        return {
          selectedCategories: selectedCategories.filter((item) => item !== category)
        };
      } else {
        		// Add new one
        return {
          selectedCategories: [...selectedCategories, category]
        };
      }
    });
  }

  
  

  componentDidMount() {
    this.props.fetchAllCountries();
    const { token } = this.props.params;
    if (token) {
      this.setState({ referral_token: token });
    }
  }

  componentDidUpdate() {
    const { rewardfulLoaded } = this.state;
    if (window.rewardful && !rewardfulLoaded) {
      this.doRewardfullReady();
    }
  }

  doRewardfullReady() {
    window.rewardful("ready", () => {
      this.setState({
        rewardfulLoaded: true,
      });
      if (window.Rewardful.referral_token) {
        this.setState({
          referral_token: window.Rewardful.referral_token,
        });
      }
    });
  }

  doResendEmail = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.props.activateResend({ email: this.state.email });
  };

  doSignup = (event) => {
    if (event) event.preventDefault();
    const { email, name, surname, companyName, country, referral_token, selectedApp } = this.state;
    const { refererLang, t } = this.props;
    		// Application selection validation
    if (!selectedApp) {
      this.setState({ registerProjectError: t('signUp.selectProjectError', 'Please select a Lappa App to continue') });
      return;
    }
    if (recaptchaResponse) {
      		// Value mapping
      let appValue = 1;
      if (selectedApp === 'LTax') appValue = 1;
      else if (selectedApp === 'LEPR') appValue = 2;
      else if (selectedApp === 'LInvoice') appValue = 3;
      else if (selectedApp === 'Unknown') appValue = 1;
      const data = {
        email: email,
        first_name: name,
        last_name: surname,
        "g-recaptcha-response": recaptchaResponse,
        company_name: companyName,
        // country: country,
        lang: refererLang,
        referral_token,
        app: [appValue],
      };
      if (this.props.params.token) {
        data.token = this.props.params.token;
      }
      this.props
        .registerUser(data)
        .then(() => {
          localStorage.removeItem('showGoogleModal');
          this.setState({ email });
        })
        .catch(() => {
          this.setState({ errorEmail: this.props.registerError || t("signUp.connectErr") });
        });
    }
  };

  handleNextStep = (event) => {
    if (event) event.preventDefault();
    const { email, name, surname, companyName, country } = this.state;
    const { t } = this.props;
    		// Validation as before
    if (
      !email ||
      !name ||
      !surname ||
      !companyName ||
      // !country ||
      !isLatin(name) ||
      !isLatin(surname) ||
      !isLatin(companyName)
    ) {
      const nameErr = isLatin(name)
        ? t("signUp.enterName")
        : "Use the Latin alphabet!";
      const surnameErr = isLatin(surname)
        ? t("signUp.enterSurname")
        : "Use the Latin alphabet!";
      const companyErr = isLatin(companyName)
        ? t("signUp.enterCompany")
        : "Use the Latin alphabet!";
      this.setState({
        errorEmail: email ? false : t("signUp.invalidEmail"),
        errorName: name && isLatin(name) ? false : nameErr,
        errorSurname: surname && isLatin(surname) ? false : surnameErr,
        errorCompanyName:
          companyName && isLatin(companyName) ? false : companyErr,
        // errorCountry: country ? false : t("signUp.enterCountry"),
      });
      return;
    }
    		// If everything is ok, go to step 2
    this.setState({ step: 2 });
  };


  validateEmail = (email) => {
    const { t } = this.props;

    if (email.length > 0 && !isEmail(email)) {
      this.setState({
        errorEmail: t("signUp.invalidEmail"),
      });
    } else {
      this.setState({
        errorEmail: false,
      });
    }
  };

  handleChange = (value, id, errorName, errorText) => {
    if (value.length > 0 && isLatin(value)) {
      this.setState({
        [id]: value,
        [errorName]: false,
      });
    } else if (value.length > 0 && !isLatin(value)) {
      this.setState({
        [id]: value,
        [errorName]: "Use the Latin alphabet!",
      });
    } else {
      this.setState({
        [id]: "",
        [errorName]: errorText,
      });
    }
  };

  handleChangeCountry = (country) => {
    const { t } = this.props;

    if (country.length > 0) {
      this.setState({
        country,
        errorCountry: false,
      });
    } else {
      this.setState({
        country: "",
        errorCountry: t("signUp.enterCountry"),
      });
    }
  };

  handleAppSelect = (value) => {
    this.setState({ selectedApp: value });
  }

  renderSignUpForm = () => {
    const { step, email, errorEmail, name, errorName, surname, errorSurname, companyName, errorCompanyName, country, errorCountry, referral_token, selectedCategories, selectedApp } = this.state;
    const { countries, registering, t, navigate } = this.props;
    
    const searchParams = new URLSearchParams(window.location.search);
    const inviteErrorMessage = searchParams.get("inviteError");
    
    if (step === 1) {
      return (
        <SignUpStep1
          t={t}
          countries={countries}
          email={email}
          errorEmail={errorEmail}
          name={name}
          errorName={errorName}
          surname={surname}
          errorSurname={errorSurname}
          companyName={companyName}
          errorCompanyName={errorCompanyName}
          // country={country}
          errorCountry={errorCountry}
          referral_token={referral_token}
          registering={registering}
          onChange={this.handleChange}
          onChangeCountry={this.handleChangeCountry}
          onValidateEmail={() => this.validateEmail(email)}
          onNext={this.handleNextStep}
          inviteErrorMessage={inviteErrorMessage}
        />
      );
    } else {
      return (
        <SignUpStep2
          t={t}
          selectedCategories={selectedCategories}
          isCategoryChecked={this.isCategoryChecked}
          onCategoryChange={this.handleCategoryChange}
          registering={registering}
          onSubmit={this.doSignup}
          onBack={() => this.setState({ step: 1 })}
          onRecaptchaChange={submitRecaptcha}
          onRecaptchaExpired={expiredRecaptcha}
          registerError={this.props.registerError}
          recaptchaSitekey={config.recaptcha.sitekey}
          selectedApp={selectedApp}
          onAppSelect={this.handleAppSelect}
          registerProjectError={this.state.registerProjectError}
        />
      );
    }
  };

  renderSuccess = () => {
    const { sent, t } = this.props;
    return (
      <Box padding="4" maxWidth="500px">
        <Text variant="headingLg" as="h2">{t("signUp.finishReg")}</Text>
        <p>
          {t("signUp.weSent1")}{" "}
          <a href='' onClick={this.doResendEmail}>
            {t("signUp.weSent2")}
          </a>
          .
        </p>
        {sent && (
          <Banner
            title='New email has been successfully sent.'
            tone='success'
          />
        )}
      </Box>
    );
  };

  render() {
    const { registered, t } = this.props;
    return (
      <>
        <PageHelmet title={"Sign Up"} />
        <AuthContainer
          title='Sign Up'
          description={"Easily manage taxes in EU or USA"}
          content={registered ? this.renderSuccess() : this.renderSignUpForm()}
          secondaryContent={
            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', alignItems: 'center' }}>
              <Text color='subdued'>Already have an account ?</Text>
              <div style={{width:'100px', marginLeft: 20}}>
                <Button onClick={() => this.props.navigate("/login")}>
                  Log in
                </Button>
              </div>
            </div>
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  registered: state.user.registered,
  registering: state.user.registering,
  registerError: state.user.registerError,
  resendError: state.user.resendError,
  countries: state.other.countriesAll,
  refererLang: state.user.refererLang,
  sent: state.user.sent,
});

const mapDispatchToProps = (defaultDispatch) => {
  const dispatch = createCustomDispatch(defaultDispatch);

  return {
    registerUser: (params) => dispatch(registerUser(params)),
    activateResend: (params) => dispatch(activateResend(params)),
    fetchAllCountries: () => dispatch(fetchAllCountries()),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SignUp))
);
